import React, { useEffect, useRef, useState } from 'react';

import { Message } from '../../@types/chat';
import { Button } from '../IDSK';
import MessageComponent from './Message';

type ConversationProps = {
    messages: Message[];
    hasMoreMessages: boolean;
    isTyping: boolean;
    onLoadMore: () => void;
};

export default function Conversation(props: ConversationProps) {
    const ref = useRef<HTMLDivElement>(null);
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const previousScrollHeightRef = useRef<number>(0);

    useEffect(() => {
        if(!ref.current) return;

        if(isLoadingMore) {
            ref.current.scrollTop = ref.current.scrollHeight - previousScrollHeightRef.current;
            setIsLoadingMore(false);
        } else {
            setTimeout(() => {
                ref.current!.scrollTop = ref.current!.scrollHeight;
            }, 10);
        }
    }, [props.messages]);

    const handleLoadMore = () => {
        if(!ref.current || isLoadingMore) {
            return;
        }

        previousScrollHeightRef.current = ref.current.scrollHeight;
        setIsLoadingMore(true);
        props.onLoadMore();
    };

    return <>
        <div className="chat--popup--conversation" ref={ref}>
            {props.hasMoreMessages && <div className="chat--popup--conversation--load-more">
                <Button onClick={handleLoadMore} disabled={isLoadingMore}>
                    {isLoadingMore ? 'Načítavam...' : 'Načítať staršie správy'}
                </Button>
            </div>}

            {props.messages.map((msg, index) =>
                <MessageComponent key={index} message={msg} />
            )}

            {props.isTyping && <span className="chat--popup--conversation--typing govuk-body-s">
                Píšem
                <span>.</span>
                <span>.</span>
                <span>.</span>
            </span>}
        </div>
    </>;
}
